import { useStore } from 'vuex';
import { computed } from 'vue';

export const useModals = () => {
  const store = useStore();
  const openModalCount = computed({
    get: () => store.getters.openModalCount,
    set: (value) => {
      store.dispatch('setOpenModalCount', value);
    },
  });
  return { openModalCount };
};